import React, {PureComponent} from 'react';
import styled from 'styled-components';

import * as validation from '../../lib/validation';
import Form from '../../components/Form';
import SideModal from '../../components/SideModal';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Notification from '../../components/Notification';

let tmpId = 0;

class CatalogTypeForm extends PureComponent {
  state = this.getInitialState();

  getInitialState() {
    return {
      validate: !!this.props.type,
      saving: false,
      type: this.props.type || {
        id: tmpId++,
        tmp: true,
        name: ''
      }
    };
  }

  // Validations
  validName = validation.create((name, {isEmpty}) => !this.state.validate || (!isEmpty(name)
    && (this.props.types.map(type => type.name).filter(type => this.props.type ? type !== this.props.type.name : true).indexOf(name) < 0)));
  validType = validation.validate({
    name: this.validName
  });

  componentDidUpdate(prevProps) {
    const {type} = this.props;

    if (prevProps.type !== type) {
      this.setState(this.getInitialState());
    }
  }

  handleSave = () => {
    this.setState({validate: true}, async () => {
      const {type} = this.state;
      const {onSave} = this.props;

      if(!this.validType(type)) {
        return;
      }

      this.setState({saving: true});
      
      if(!await onSave(type)) {
        this.setState({saving: false});
      }
    });
  }

  handleChangeName = e => {
    const value = e.target.value;
    
    this.setState(prevState => ({
      type: {
        ...prevState.type,
        name: value
      }
    }));
  }

  render() {
    const {onClose, open} = this.props;
    const {type, saving} = this.state;

    return (
      <Form onSubmit={this.handleSave}>
        <SideModal
          title={type.tmp ? 'New Catalog Type' : 'Edit Catalog Type'}
          open={open}
          onClose={onClose}
          options={[
            <Button type="submit" disabled={saving}>Save Catalog Type</Button>,
            <Button secondary onClick={onClose}>Cancel</Button>
          ]}>
          <SideModal.Content>
            <Form.Group>
              {this.props.type && (
                <Warning mini error>
                  Renaming this type also renames it on every catalog item that uses it.
                </Warning>
              )}
              <Input
                required
                type="text"
                id="catalog-type-name"
                label="Name"
                value={type.name}
                invalid={!this.validName(type.name)}
                onChange={this.handleChangeName}
                validationText="Please enter a unique name"
              />
            </Form.Group>
          </SideModal.Content>
        </SideModal>
      </Form>
    );
  }
}

const Warning = styled(Notification)`
  margin-bottom: 1rem;
  font-size: 1.125rem;
`;

export default CatalogTypeForm;